(() => {
  function init(root = document) {
    root.querySelectorAll('.mw-inline-model model-viewer').forEach(viewer => {
      if (viewer.dataset.mwReady) return;
      viewer.dataset.mwReady = 'true';
      const hint = viewer.parentElement.querySelector('.mw-model-hint');
      viewer.addEventListener('load', () => { hint.textContent = ''; });
      viewer.addEventListener('error', () => { hint.textContent = 'Unable to load 3D model. Please refresh to try again.'; });
      if (viewer.loaded) hint.textContent = '';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
